import { UseFormReturn } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';

import InputFormField from 'src/registry/components/forms/InputFormField';
import { Form, FormControl, FormControlStack, FormField, FormItem, FormLabel, FormMessage } from 'src/registry/ui/Form';
import { commonMessages, generalMessages } from 'src/utils/messages';
import { ServicePlanFormSchemaValues } from 'src/features/servicePlans/utils/formSchema';
import { servicePlansMessages } from 'src/features/servicePlans/utils/messages';
import { useListServicePlanCategories } from 'src/features/servicePlanCategory/api/useListServicePlanCategories';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'src/registry/ui/Select';
import TextareaFormField from 'src/registry/components/forms/TextareaFormField';

type ServicePlanFormProps = {
    form: UseFormReturn<ServicePlanFormSchemaValues>;
    onSubmit: (values: ServicePlanFormSchemaValues) => void;
};

function ServicePlanForm({ onSubmit, form }: ServicePlanFormProps) {
    const { formatMessage } = useIntl();

    const { data: listServicePlanCategories } = useListServicePlanCategories({});

    return (
        <Form form={form} onSubmit={form.handleSubmit(onSubmit)} variant="dialog">
            <InputFormField<ServicePlanFormSchemaValues>
                form={form}
                name="name"
                label={formatMessage(commonMessages.name)}
            />
            <InputFormField<ServicePlanFormSchemaValues>
                form={form}
                name="code"
                label={formatMessage(servicePlansMessages.code)}
            />
            <TextareaFormField<ServicePlanFormSchemaValues>
                form={form}
                name="description"
                label={formatMessage(generalMessages.description)}
            />
            <InputFormField<ServicePlanFormSchemaValues>
                form={form}
                name="external_service_plan_id"
                required={false}
                label={formatMessage(servicePlansMessages.externalServicePlan)}
            />
            <InputFormField<ServicePlanFormSchemaValues>
                form={form}
                name="invoice_name"
                required={false}
                label={formatMessage(servicePlansMessages.invoiceName)}
            />
            <FormField
                control={form.control}
                name="category"
                render={({ field }) => (
                    <FormItem variant="dialog">
                        <FormLabel variant="dialog">
                            <FormattedMessage {...servicePlansMessages.category} />
                        </FormLabel>
                        <FormControlStack>
                            <FormControl>
                                <Select onValueChange={field.onChange} value={field.value ?? ''}>
                                    <SelectTrigger className="w-full">
                                        <SelectValue
                                            placeholder={`${formatMessage(servicePlansMessages.category)}...`}
                                        />
                                    </SelectTrigger>
                                    <SelectContent>
                                        {listServicePlanCategories?.results?.map((option) => (
                                            <SelectItem key={option.id} value={option.id}>
                                                {option.name}
                                            </SelectItem>
                                        ))}
                                    </SelectContent>
                                </Select>
                            </FormControl>
                            <FormMessage />
                        </FormControlStack>
                    </FormItem>
                )}
            />
        </Form>
    );
}

export default ServicePlanForm;
